import { getServiceIcon, getServiceIconTone } from "@/lib/services/icons";
import { cn } from "@/lib/utils";

export function ServiceIconBadge({
  iconName,
  iconColor,
  categorySlug,
  className,
  iconClassName,
}: {
  iconName: string | null;
  iconColor?: string | null;
  categorySlug?: string;
  className?: string;
  iconClassName?: string;
}) {
  const Icon = getServiceIcon(iconName, categorySlug);
  const tone = getServiceIconTone(iconColor, iconName, categorySlug ?? "");

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-xl",
        tone.className,
        className,
      )}
      style={tone.style}
    >
      <Icon className={iconClassName} />
    </div>
  );
}
